import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/feed-discovery/components/FeedDiscoveryContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AppShell.tsx");
